import { jsx as _jsx } from "react/jsx-runtime";
import { AlertDialog } from '@shared-app/ui';
import { useTranslation } from 'react-i18next';
export function ConfirmationModal({ handleSubmit, isVisible, handleClose }) {
    const { t } = useTranslation();
    return (_jsx(AlertDialog, { open: isVisible, handleClose: handleClose, title: t('Confirm Unit change'), details: t('Changing the unit will reset all previously entered data. Are you sure you want to proceed?'), buttonText: t('Proceed'), onClick: handleSubmit }));
}
